import { reduxKey } from './constants';
import { PapiComment } from '@wix/da-papi-types';

// This is taken from PHP side see constants.inc.php
export enum CommentableTypes {
  COMMENT_DEVIATION = 1,
  COMMENT_NEWS = 2,
  COMMENT_SOFTWARE = 3,
  COMMENT_USER = 4,
  COMMENT_JOURNAL = 5,
  COMMENT_POLL = 6,
  COMMENT_EVENT = 7,
  COMMENT_HELP = 9,
  COMMENT_PROJECT_MANAGER = 10,
  COMMENT_REPORT = 11,
  COMMENT_CALENDAR = 12,
  COMMENT_PRINTADMIN = 13,
  COMMENT_POLL_BLOG = 14,
  COMMENT_PROJECT_MAIN = 15,
  COMMENT_PROJECT_SUMMIT = 16,
  COMMENT_SUMMIT_MANAGER = 17,
  COMMENT_FORUM = 18,
  COMMENT_USERFORUM = 19,
  COMMENT_GALLERY = 20,
  COMMENT_COLLECTION = 21,
  COMMENT_COMMENT = 24,
  COMMENT_MESSAGEBOX = 25,
  COMMENT_NOTE = 26,
  COMMENT_BPP_MSG_MODULE = 29,
  COMMENT_CRITIQUE = 30,
  COMMENT_DEVMEET = 38,
  COMMENT_THREADNOTE = 39,
  COMMENT_SHOP = 40,
  COMMENT_PAGE_MODULE = 41,
  COMMENT_MODULE_CLUBCONVERT = 42,
  COMMENT_MODULE_STORE = 43,
  COMMENT_MODULE_TICKETTRACKER = 44,
  COMMENT_MODULE_SHOUTFORUM = 45,
  COMMENT_MODULE_CONVERSATION = 46,
  COMMENT_MODULE_BULLETIN = 47,
  COMMENT_ORDER = 48,
  COMMENT_BPP_MSG_MODULE_PUBLIC = 49,
  COMMENT_BADGE = 53,
  COMMENT_MODULE_ADMINSTATS = 60,
  COMMENT_STASH_DEVIATION = 61,
  COMMENT_STATUS = 62,
  COMMENT_COMMISSION = 66,
}

export enum RequestError {
  Banned = 0,
  Throttled = 1,
  GeneralError = 2,
}

export interface CommentStoreState {
  [reduxKey]?: {
    [k: number]: PapiComment;
  };
}

export type EditingState = 'editing' | 'replying' | 'none';
